export const cplNewbuildingSaleTypes = [
  {
    name: 'Договор уступки права требования',
    key: 'dupt',
  },
  {
    name: 'Свободная продажа',
    key: 'free',
  },
];
